import React from 'react';
import styled from 'styled-components';

const CorePicture = (props) => {
  const { src, alt, height, className } = props;

  let avifSrc;
  let webpSrc;
  let origSrc = src;
  if (typeof src === 'object') {
    avifSrc = src.avif;
    webpSrc = src.webp;
    origSrc = src.src;
  }

  return (
    <StyledPictureWrapper className={className} height={height}>
      <StyledPicture height={height}>
        {avifSrc && <source srcSet={avifSrc} type="image/avif" />}
        {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
        <img src={origSrc} alt={alt} />
      </StyledPicture>
    </StyledPictureWrapper>
  );
};

const StyledPictureWrapper = styled.div`
  width: 100%;
  ${({ height }) => (height ? `height: ${height}px;` : '')}

  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledPicture = styled.picture`
  margin: 0 auto;
  ${({ height }) => (height ? `max-height: ${height}px;` : '')}

  img,
  source {
    display: block;
    margin: 0 auto;
    ${({ height }) => (height ? `max-height: ${height}px;` : '')}
  }
`;

export default CorePicture;
